import { z } from 'zod';

export const jIACapabilitiesSchema = z.union([
    z.literal('summarize'),
    z.literal('develop'),
    z.literal('reformulate'),
    z.literal('tldr'),
    z.literal('en'),
    z.literal('es'),
    z.literal('formal'),
    z.literal('funny'),
]);
export type JIACapabilities = z.infer<typeof jIACapabilitiesSchema>;

export const textEnhanceResponseSchema = z.object({
    text: z.string(),
});
export type TextEnhanceResponse = z.infer<typeof textEnhanceResponseSchema>;
